import { Alert, AlertColor, AlertProps, AlertTitle } from '@mui/material';
import { CustomContentProps, SnackbarContent, useSnackbar } from 'notistack';
import React from 'react';

export type SnackbarProps = {
  severity?: AlertColor;
  title?: string;
  AlertProps?: AlertProps;
} & Partial<CustomContentProps>;

export const Snackbar = React.forwardRef<HTMLDivElement, SnackbarProps>(
  (props, ref) => {
    const { id, message, title, severity, AlertProps = {}, ...rest } = props;
    const { closeSnackbar } = useSnackbar();
    return (
      <SnackbarContent ref={ref} role="alert" {...rest}>
        <Alert
          variant="filled"
          onClose={() => closeSnackbar(id)}
          style={{ color: 'white' }}
          data-testid="SnackBar.Alert"
          {...AlertProps}
          sx={{ width: '100%', ...AlertProps.sx }}
          severity={severity}
        >
          {title && <AlertTitle>{title}</AlertTitle>}
          {message}
        </Alert>
      </SnackbarContent>
    );
  },
);

export default Snackbar;
